export default "__VITE_ASSET__BmHF23qx__"